import moment from "moment";

const countDaysBetweenDates = ({ toDate, fromDate, precise = false }) => {
    let tDate, fDate;

    if (!toDate) {
        tDate = moment();
        return Math.ceil(tDate.diff(fromDate, "days", precise));
    } else if (!fromDate) {
        fDate = moment();
        return Math.ceil(toDate.diff(fDate, "days", precise));
    } else {
        toDate = moment(toDate);
        fromDate = moment(fromDate);
        return Math.ceil(toDate.diff(fromDate, "days", precise));
    }
};

export default countDaysBetweenDates;
